"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonSchemaV004 = void 0;
const schema_json_1 = require("../0.0.3/schema_json");
exports.jsonSchemaV004 = Object.assign(Object.assign({}, schema_json_1.jsonSchemaV003), { $id: "http://schema.canotic.com/v0.0.4/", definitions: Object.assign(Object.assign({}, schema_json_1.jsonSchemaV003.definitions), { INSTRUCTIONS: {
            $id: "instructions",
            type: "array",
            items: {
                type: "object",
                required: ["title", "detail"],
                properties: {
                    title: {
                        $ref: "text"
                    },
                    detail: {
                        $ref: "text"
                    }
                }
            },
            minItems: 1
        }, IMAGE: Object.assign(Object.assign({}, schema_json_1.jsonSchemaV003.definitions.IMAGE), { pattern: "^(?:http(s?)|data)://[\\w\\-\\._~:/?#[\\]@%!\\$&'\\(\\)\\*\\+,;=.]+" }), IMAGE_PRESENTATION: {
            $id: "image-presentation",
            description: "An container with an image with additional presentation properties.",
            type: "object",
            properties: {
                image: {
                    $ref: "image"
                },
                timeout: {
                    type: "number",
                    minimum: 0,
                    description: "Time in (fractional) seconds, after which the object object vanishes (is hidden)."
                }
            },
            required: ["image"]
        }, VIDEO: Object.assign(Object.assign({}, schema_json_1.jsonSchemaV003.definitions.VIDEO), { pattern: "^(?:http(s?)|data)://[\\w\\-\\._~:/?#[\\]@%!\\$&'\\(\\)\\*\\+,;=.]+" }), AUDIO: Object.assign(Object.assign({}, schema_json_1.jsonSchemaV003.definitions.AUDIO), { pattern: "^(?:http(s?)|data)://[\\w\\-\\._~:/?#[\\]@%!\\$&'\\(\\)\\*\\+,;=.]+" }), SATELLITE: Object.assign(Object.assign({}, schema_json_1.jsonSchemaV003.definitions.SATELLITE), { pattern: "^(?:http(s?)|data)://[\\w\\-\\._~:/?#[\\]@%!\\$&'\\(\\)\\*\\+,;=.]+" }), VIDEO_BOUNDING_BOX: {
            $id: "video-bounding-box",
            description: "A 2d square annotation on a video",
            type: "object",
            properties: {
                videoUrl: {
                    $ref: "video"
                },
                annotations: {
                    type: "array",
                    description: "Array of annotations for each frame. If `numFrames` (and `startFrame`) is specified, this will contain frames for the duration only.",
                    items: {
                        type: "object",
                        properties: {
                            timestamp: {
                                type: "number",
                                description: "timestamp of bounding box frame, relative to the whole video"
                            },
                            instances: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        id: {
                                            type: "string",
                                            description: "identifier to track identity of each annotation accross frames"
                                        },
                                        box: {
                                            $ref: "bounding-box"
                                        },
                                        keyFrame: {
                                            type: "boolean"
                                        }
                                    },
                                    required: ["id", "box", "keyFrame"]
                                }
                            }
                        },
                        required: ["timestamp", "instances"]
                    }
                },
                choices: {
                    type: "array",
                    description: "Possible values for underlying bounding boxes",
                    items: {
                        $ref: "choice"
                    }
                },
                startFrame: {
                    type: "integer",
                    default: 0,
                    description: "Start frame to annotate"
                },
                numFrames: {
                    type: "integer",
                    description: "Number of frames to annotate"
                },
                minWidth: {
                    type: "integer",
                    minimum: 0,
                    description: "Minimum width of bounding box"
                },
                minHeight: {
                    type: "integer",
                    minimum: 0,
                    description: "Minimum height of bounding box"
                },
                frameRate: {
                    type: "number",
                    default: 1,
                    description: "Number of frames labeled in one second."
                },
                bufferSize: {
                    type: "integer",
                    default: 0,
                    description: "Number of frames to be presented to human labelers, before and after the frames to annotate"
                }
            },
            required: ["videoUrl", "frameRate", "choices"]
        }, IMAGE_SEMANTIC_SEGMENTATION: {
            $id: "image-semantic-segmentation",
            description: "Pixel-wise semantic segmentation of an image where every pixel of the image is classified.",
            type: "object",
            properties: {
                imageUrl: {
                    $ref: "image"
                },
                annotations: {
                    type: "object",
                    properties: {
                        segments: {
                            type: "array",
                            items: {
                                $ref: "image-segment"
                            }
                        },
                        combined: {
                            $ref: "image"
                        }
                    },
                    required: ["segments"]
                },
                choices: {
                    type: "array",
                    description: "Objects classes you want to annotate",
                    items: {
                        $ref: "choice"
                    }
                },
                inclusion: {
                    type: "array",
                    description: "Pixels to be shown in the annotation tool.",
                    items: {
                        $ref: "image"
                    }
                }
            },
            required: ["imageUrl", "choices"]
        }, IMAGE_INSTANCE_SEGMENTATION: {
            $id: "image-instance-segmentation",
            description: "Instance aware segmentation, also known as panoptic segmentation of image. ",
            type: "object",
            properties: {
                imageUrl: {
                    $ref: "image"
                },
                annotations: {
                    type: "object",
                    properties: {
                        instances: {
                            type: "array",
                            items: {
                                $ref: "image-segment"
                            }
                        },
                        combined: {
                            $ref: "image"
                        }
                    },
                    required: ["instances"]
                },
                choices: {
                    type: "array",
                    description: "Objects classes you want to annotate",
                    items: {
                        $ref: "choice"
                    }
                },
                inclusion: {
                    type: "array",
                    description: "Pixels to be shown in the annotation tool.",
                    items: {
                        $ref: "image"
                    }
                }
            },
            required: ["imageUrl", "choices"]
        }, AUDIO_SPAN: {
            $id: "audio-span",
            type: "object",
            description: "Data that represents a annotated span in audio transcription",
            properties: {
                start: {
                    type: "number",
                    minimum: 0,
                    description: "start time of utterance in seconds. Relative to beginning of the audio file"
                },
                end: {
                    type: "number",
                    minimum: 0,
                    description: "end time of utterance seconds. Relative to beginning of the audio file"
                },
                selection: {
                    $ref: "choice"
                },
                instanceId: {
                    type: "string",
                    description: "Identifier of speaker in the audio"
                },
                channel: {
                    type: "integer",
                    description: "Audio channel number which contains utterance of the word",
                    minimum: 1
                }
            },
            required: ["start", "end", "selection"]
        }, AUDIO_TRANSCRIPTION_WORD: {
            $id: "audio-transcription-word",
            type: "object",
            description: "Data that represents a transcription word in audio transcription",
            properties: {
                start: {
                    type: "number",
                    minimum: 0,
                    description: "Start time of utterance of the word in seconds. Relative to beginning of the audio file"
                },
                end: {
                    type: "number",
                    minimum: 0,
                    description: "End time of utterance of the word in seconds. Relative to beginning of the audio file"
                },
                word: {
                    type: "string",
                    description: "Transcribed word"
                },
                speaker: {
                    type: "integer",
                    minimum: 0,
                    default: 0,
                    description: "Speaker identity, corresponds to the channel in the annotations"
                }
            },
            required: ["start", "end", "word"]
        }, AUDIO_SEGMENT: {
            $id: "audio-segment",
            type: "object",
            description: "Instance aware annotation for spans of audio data",
            properties: {
                audioUrl: {
                    $ref: "audio"
                },
                choices: {
                    type: "array",
                    description: "List of choices that will be shown to the task annotator",
                    items: {
                        $ref: "choice"
                    },
                    minItems: 1
                },
                annotations: {
                    type: "array",
                    description: "Array of annotated spans in the audio",
                    items: {
                        $ref: "audio-span"
                    }
                },
                minSpanDuration: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    description: "Minimum duration of annotated spans in seconds"
                },
                maxSpanDuration: {
                    type: "number",
                    minimum: 0,
                    description: "Maximum duration of annotated spans in seconds. Default to whatever length"
                },
                startTime: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    description: "Start time of the duration to annotate in seconds"
                },
                duration: {
                    type: "number",
                    minimum: 0,
                    description: "Duration to annotate in seconds. Default to the while audio duration minus `startTime`"
                },
                transcript: {
                    type: "object",
                    description: "Transcription of the audio data",
                    properties: {
                        confidence: {
                            type: "number",
                            minimum: 0,
                            maximum: 1,
                            description: "Level of confidence of the transcription"
                        },
                        text: {
                            type: "string",
                            description: "Concatenated string of transcribed words"
                        },
                        words: {
                            type: "array",
                            description: "Array of transcribed words",
                            items: {
                                $ref: "audio-transcription-word"
                            }
                        }
                    },
                    required: ["text"]
                }
            },
            required: ["audioUrl", "choices"]
        }, ENTITY_SPAN: {
            $id: "entity-span",
            description: "Result of token annotation",
            type: "object",
            properties: {
                uuid: {
                    $ref: "text"
                },
                tokenStart: {
                    type: "integer"
                },
                tokenEnd: {
                    type: "integer"
                },
                entity: {
                    $ref: "choice"
                },
                annotationSource: {
                    $ref: "text"
                }
            },
            required: ["uuid", "tokenStart", "tokenEnd"]
        }, ENTITY_RELATIONSHIP: {
            $id: "entity-relationship",
            description: "Result of relationship annotation",
            type: "object",
            properties: {
                headUuid: {
                    $ref: "text"
                },
                tailUuid: {
                    $ref: "text"
                },
                entity: {
                    $ref: "choice"
                }
            },
            required: ["headUuid", "tailUuid", "entity"]
        }, TOKEN_ANNOTATION: {
            $id: "token-annotation",
            description: "Annotation on a tokenized natural language text",
            type: "object",
            properties: {
                tokens: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            text: {
                                $ref: "text"
                            },
                            whitespace: {
                                $ref: "text"
                            },
                            mask: {
                                $ref: "binary-choice"
                            }
                        },
                        required: ["text", "whitespace"]
                    }
                },
                choices: {
                    type: "array",
                    description: "List of choices that will be shown to the task annotator",
                    items: {
                        $ref: "choice"
                    },
                    minItems: 1
                },
                relationshipChoices: {
                    type: "array",
                    description: "List of choices that will be shown to the task annotator",
                    items: {
                        $ref: "choice"
                    },
                    minItems: 1
                },
                annotations: {
                    type: "object",
                    properties: {
                        entitySpans: {
                            type: "array",
                            items: {
                                $ref: "entity-span"
                            }
                        },
                        entityRelationships: {
                            type: "array",
                            items: {
                                $ref: "entity-relationship"
                            }
                        }
                    }
                }
            },
            required: ["tokens", "choices"]
        }, CHOICE: {
            $id: "choice",
            description: "Choice type",
            type: "object",
            properties: {
                value: {
                    anyOf: [
                        {
                            $ref: "text"
                        }
                    ]
                },
                tag: {
                    type: "string"
                },
                parent: {
                    type: "string",
                    description: "value of parent node"
                },
                selectable: {
                    type: "boolean",
                    description: "whether the parent node is selectable."
                },
                instructions: {
                    type: "string",
                    description: "Optional choice specific instructions."
                },
                examples: {
                    type: "string",
                    description: "Optional examples of choice class."
                }
            },
            required: ["value", "tag"]
        }, VIDEO_BOUNDING_BOX_KEYPOINT: {
            $id: "video-bounding-box-keypoint",
            description: "Annotation on a video consisting of 2D rectangles and named points.",
            type: "object",
            properties: {
                videoUrl: {
                    $ref: "video"
                },
                annotations: {
                    type: "array",
                    description: "Array of annotations for each frame. If `numFrames` (and `startFrame`) is specified, this will contain frames for the duration only.",
                    items: {
                        type: "object",
                        properties: {
                            timestamp: {
                                type: "number",
                                description: "timestamp of bounding box frame, relative to the whole video"
                            },
                            instances: {
                                type: "array",
                                items: {
                                    type: "object",
                                    properties: {
                                        id: {
                                            type: "string",
                                            description: "identifier to track identity of each annotation accross frames"
                                        },
                                        box: {
                                            $ref: "bounding-box"
                                        },
                                        keypoints: {
                                            type: "array",
                                            items: {
                                                $ref: "key-point"
                                            }
                                        },
                                        keyFrame: {
                                            type: "boolean"
                                        }
                                    },
                                    required: [
                                        "id",
                                        "box",
                                        "keypoints",
                                        "keyFrame"
                                    ]
                                }
                            }
                        },
                        required: ["timestamp", "instances"]
                    }
                },
                boxChoices: {
                    type: "array",
                    description: "Possible values for underlying bounding boxes",
                    items: {
                        $ref: "choice"
                    }
                },
                keypointChoices: {
                    type: "array",
                    description: "Possible values for underlying key points",
                    items: {
                        $ref: "choice"
                    }
                },
                startFrame: {
                    type: "integer",
                    default: 0,
                    description: "Start frame to annotate"
                },
                numFrames: {
                    type: "integer",
                    description: "Number of frames to annotate"
                },
                minWidth: {
                    type: "integer",
                    minimum: 0,
                    description: "Minimum width of bounding box"
                },
                minHeight: {
                    type: "integer",
                    minimum: 0,
                    description: "Minimum height of bounding box"
                },
                frameRate: {
                    type: "number",
                    default: 1,
                    description: "Number of frames labeled in one second."
                },
                bufferSize: {
                    type: "integer",
                    default: 0,
                    description: "Number of frames to be presented to human labelers, before and after the frames to annotate"
                }
            },
            required: ["videoUrl", "frameRate", "boxChoices", "keypointChoices"]
        }, CHECKBOX: {
            $id: "checkbox",
            description: "Checkbox with optional name and two state switch.",
            type: "object",
            properties: {
                name: {
                    $ref: "text"
                },
                checked: {
                    type: "boolean"
                }
            },
            required: ["checked"]
        }, CHECKBOX_LIST: {
            $id: "checkbox-list",
            description: "List of checkboxes with name and two state switch.",
            type: "array",
            items: {
                $ref: "checkbox"
            },
            minItems: 1
        }, BLOCK: {
            $id: "block",
            description: "An object whose contents are rendered in a block.",
            type: "object"
        }, BOUNDING_BOX: {
            $id: "bounding-box",
            type: "object",
            properties: {
                top: {
                    type: "integer",
                    minimum: 0,
                    description: "The distance, in pixels, between the top of the bounding box and the left top of the image."
                },
                left: {
                    type: "integer",
                    minimum: 0,
                    description: "The distance, in pixels, between the left of the bounding box and the left border of the image."
                },
                width: {
                    type: "integer",
                    minimum: 0,
                    description: "The width, in pixels, of the bounding box."
                },
                height: {
                    type: "integer",
                    minimum: 0,
                    description: "The height, in pixels, of the bounding box."
                },
                selection: {
                    $ref: "choice"
                },
                minWidth: {
                    type: "integer",
                    minimum: 0,
                    description: "Minimum width of bounding box"
                },
                minHeight: {
                    type: "integer",
                    minimum: 0,
                    description: "Minimum height of bounding box"
                },
                subAnnotations: {
                    type: "array",
                    items: {
                        $ref: "structured"
                    }
                }
            },
            required: ["top", "left", "width", "height"]
        }, IMAGE_BOUNDING_BOX: {
            $id: "image-bounding-box",
            description: "A 2d square annotation on an image",
            type: "object",
            properties: {
                imageUrl: {
                    $ref: "image"
                },
                annotations: {
                    type: "array",
                    items: {
                        $ref: "bounding-box"
                    }
                },
                choices: {
                    type: "array",
                    description: "Possible values for underlying bounding boxes",
                    items: {
                        $ref: "choice"
                    }
                },
                minWidth: {
                    type: "integer",
                    minimum: 0,
                    default: 0,
                    description: "Minimum width of bounding box"
                },
                minHeight: {
                    type: "integer",
                    minimum: 0,
                    description: "Minimum height of bounding box"
                },
                minAnnotations: {
                    type: "integer",
                    minimum: 0,
                    default: 0,
                    description: "The minimum number of points that will be returned. Should only be used when one is certain that the image contains at least this many annotatable cuboids."
                },
                maxAnnotations: {
                    type: "integer",
                    description: "The maximum number of points that can be annotated in the image. A value of 0 (default) means no limit."
                },
                subAnnotations: {
                    type: "array",
                    items: {
                        $ref: "structured"
                    }
                }
            },
            required: ["imageUrl"]
        }, KEY_POINT: {
            $id: "key-point",
            description: "A point annotation on a specific point on an image",
            type: "object",
            properties: {
                x: {
                    type: "integer",
                    minimum: 0,
                    description: "The distance, in pixels, between the point and the left border of the image."
                },
                y: {
                    type: "integer",
                    minimum: 0,
                    description: "The distance, in pixels, between the point and the top border of the image."
                },
                description: {
                    type: "string"
                },
                visible: {
                    type: "boolean",
                    default: true,
                    description: "true if the key point is visible, false if occluded"
                },
                keyFrame: {
                    type: "boolean"
                },
                selection: {
                    $ref: "choice"
                }
            },
            required: ["x", "y", "selection"],
            additionalProperties: false
        }, SATELLITE_POLYGON: {
            $id: "satellite-polygon",
            description: "A polygon annotation on an GeoTIFF file",
            type: "object",
            properties: {
                imageUrl: {
                    $ref: "satellite"
                },
                annotations: {
                    type: "array",
                    items: {
                        allOf: [
                            {
                                $ref: "geojson-feature"
                            },
                            {
                                type: "object",
                                properties: {
                                    type: {
                                        type: "string",
                                        const: "Feature"
                                    },
                                    properties: {
                                        type: "object",
                                        description: "Key-value pairs containing selected choice and sub annotations",
                                        properties: {
                                            __selection: {
                                                description: "Value of selected choice",
                                                type: "string"
                                            }
                                        },
                                        additionalProperties: true
                                    },
                                    geometry: {
                                        $ref: "geojson-polygon"
                                    }
                                }
                            }
                        ]
                    }
                },
                choices: {
                    type: "array",
                    description: "Possible values for underlying bounding boxes",
                    items: {
                        $ref: "choice"
                    }
                },
                subAnnotations: {
                    type: "array",
                    items: {
                        $ref: "structured"
                    }
                },
                minAnnotations: {
                    type: "integer",
                    minimum: 0,
                    default: 0,
                    description: "The minimum number of points that will be returned. Should only be used when one is certain that the image contains at least this many annotatable cuboids."
                },
                maxAnnotations: {
                    type: "integer",
                    description: "The maximum number of points that can be annotated in the image. A value of 0 (default) means no limit."
                }
            },
            required: ["imageUrl"]
        }, GEOJSON_COORDINATE: {
            $id: "geojson-coordinate",
            title: "GeoJSON Coordinate",
            type: "array",
            minItems: 2,
            items: {
                type: "number"
            }
        }, GEOJSON_BBOX: {
            $id: "geojson-bbox",
            title: "GeoJSON Bounding Box",
            type: "array",
            minItems: 4,
            items: {
                type: "number"
            }
        }, GEOJSON_POINT: {
            $id: "geojson-point",
            title: "GeoJSON Point",
            type: "object",
            required: ["type", "coordinates"],
            properties: {
                type: {
                    type: "string",
                    enum: ["Point"]
                },
                coordinates: {
                    $ref: "geojson-coordinate"
                },
                bbox: {
                    $ref: "geojson-bbox"
                }
            }
        }, GEOJSON_LINE_STRING: {
            $id: "geojson-line-string",
            title: "GeoJSON LineString",
            type: "object",
            required: ["type", "coordinates"],
            properties: {
                type: {
                    type: "string",
                    enum: ["LineString"]
                },
                coordinates: {
                    type: "array",
                    minItems: 2,
                    items: {
                        $ref: "geojson-coordinate"
                    }
                },
                bbox: {
                    $ref: "geojson-bbox"
                }
            }
        }, GEOJSON_POLYGON: {
            $id: "geojson-polygon",
            title: "GeoJSON Polygon",
            type: "object",
            required: ["type", "coordinates"],
            properties: {
                type: {
                    type: "string",
                    enum: ["Polygon"]
                },
                coordinates: {
                    type: "array",
                    items: {
                        type: "array",
                        minItems: 4,
                        items: {
                            $ref: "geojson-coordinate"
                        }
                    }
                },
                bbox: {
                    $ref: "geojson-bbox"
                }
            }
        }, GEOJSON_MULTI_POINT: {
            $id: "geojson-multi-point",
            title: "GeoJSON MultiPoint",
            type: "object",
            required: ["type", "coordinates"],
            properties: {
                type: {
                    type: "string",
                    enum: ["MultiPoint"]
                },
                coordinates: {
                    type: "array",
                    items: {
                        $ref: "geojson-coordinate"
                    }
                },
                bbox: {
                    $ref: "geojson-bbox"
                }
            }
        }, GEOJSON_MULTI_LINE_STRING: {
            $id: "geojson-multi-line-string",
            title: "GeoJSON MultiLineString",
            type: "object",
            required: ["type", "coordinates"],
            properties: {
                type: {
                    type: "string",
                    enum: ["MultiLineString"]
                },
                coordinates: {
                    type: "array",
                    items: {
                        type: "array",
                        minItems: 2,
                        items: {
                            $ref: "geojson-coordinate"
                        }
                    }
                },
                bbox: {
                    $ref: "geojson-bbox"
                }
            }
        }, GEOJSON_MULTI_POLYGON: {
            $id: "geojson-multi-polygon",
            title: "GeoJSON MultiPolygon",
            type: "object",
            required: ["type", "coordinates"],
            properties: {
                type: {
                    type: "string",
                    enum: ["MultiPolygon"]
                },
                coordinates: {
                    type: "array",
                    items: {
                        type: "array",
                        items: {
                            type: "array",
                            minItems: 4,
                            items: {
                                $ref: "geojson-coordinate"
                            }
                        }
                    }
                },
                bbox: {
                    $ref: "geojson-bbox"
                }
            }
        }, GEOJSON_GEOMETRY_COLLECTION: {
            $id: "geojson-geometry-collection",
            title: "GeoJSON GeometryCollection",
            type: "object",
            required: ["type", "geometries"],
            properties: {
                type: {
                    type: "string",
                    enum: ["GeometryCollection"]
                },
                geometries: {
                    type: "array",
                    items: {
                        oneOf: [
                            {
                                $ref: "geojson-point"
                            },
                            {
                                $ref: "geojson-line-string"
                            },
                            {
                                $ref: "geojson-polygon"
                            },
                            {
                                $ref: "geojson-multi-point"
                            },
                            {
                                $ref: "geojson-multi-line-string"
                            },
                            {
                                $ref: "geojson-multi-polygon"
                            }
                        ]
                    }
                },
                bbox: {
                    $ref: "geojson-bbox"
                }
            }
        }, GEOJSON_FEATURE: {
            $id: "geojson-feature",
            title: "GeoJSON Feature",
            type: "object",
            required: ["type", "properties", "geometry"],
            properties: {
                type: {
                    type: "string",
                    enum: ["Feature"]
                },
                properties: {
                    oneOf: [
                        {
                            type: "null"
                        },
                        {
                            type: "object"
                        }
                    ]
                },
                geometry: {
                    oneOf: [
                        {
                            type: "null"
                        },
                        {
                            $ref: "geojson-point"
                        },
                        {
                            $ref: "geojson-line-string"
                        },
                        {
                            $ref: "geojson-polygon"
                        },
                        {
                            $ref: "geojson-multi-point"
                        },
                        {
                            $ref: "geojson-multi-line-string"
                        },
                        {
                            $ref: "geojson-multi-polygon"
                        },
                        {
                            $ref: "geojson-geometry-collection"
                        }
                    ]
                },
                bbox: {
                    $ref: "geojson-bbox"
                }
            }
        }, GEOJSON_FEATURE_COLLECTION: {
            $id: "geojson-feature-collection",
            title: "GeoJSON FeatureCollection",
            type: "object",
            required: ["type", "features"],
            properties: {
                type: {
                    type: "string",
                    enum: ["FeatureCollection"]
                },
                features: {
                    type: "array",
                    items: {
                        $ref: "geojson-feature"
                    }
                },
                bbox: {
                    $ref: "geojson-bbox"
                }
            }
        }, DOCUMENT: {
            $id: "document",
            description: "The URL of a PDF file",
            type: "string",
            pattern: "^(?:http(s?)|data)://[\\w\\-\\._~:/?#[\\]@%!\\$&'\\(\\)\\*\\+,;=.]+"
        } }) });
